import { ModalTypes } from "../TargetTypeManagement";
import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeSectorList } from "../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../validation/ToastContainer";

export class SectorsManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {

        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit Sector",
            text: "Select Sector",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedSector: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {


        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove Sector",
            text: "Select Sectors",
            elements: this.elements,
            onSubmit: (sectors) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected sectors?',
                        'Remove Sectors',
                        () => removeSectorList(sectors)
                            .then((errors) => {
                                setShowModal(false);
                                if (errors.length > 0) {
                                    errors.forEach(errMessage => {
                                        showDangerToast(errMessage, "Error", "Unable to delete Sector");
                                    })
                                } else {
                                    showSuccessToast("Sectors were removed", "Remove Sector")
                                }
                            }),
                        undefined,
                        'Remove Sectors'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }

}
